/*
 *   Copyright (c) 2023
 *   All rights reserved.
 */
import { takeEvery, call, put, all } from "redux-saga/effects";

import * as types from "../config/actionType";
import * as service from "../services/paiementService";
import * as actions from "../action/paiementAction";

function* loadPaiementsForOneCustomer(data) {
  try {
    yield put(actions.loadPaiementRequestAction());
    const paiements = yield call(service.getListePaiementOFOneCustomer, data);
    yield put(actions.paiementLoadedAction(paiements));
  } catch (error) {
    yield put(actions.loadPaiementErrorAction(error));
    yield put(actions.paiementLoadedAction([]));
  } finally {
    yield put(actions.loadPaiementFinishAction());
  }
}

function* loadPaiementsForAllCustomer(data) {
  try {
    yield put(actions.loadPaiementRequestAction());
    const paiements = yield call(service.getListePaiementAllCustumer, data);
    yield put(actions.paiementLoadedAction(paiements));
  } catch (error) {
    yield put(actions.loadPaiementErrorAction(error));
    yield put(actions.paiementLoadedAction([]));
  } finally {
    yield put(actions.loadPaiementFinishAction());
  }
}

function* addPaiement(data) {
  try {
    yield put(actions.loadPaiementRequestAction());
    yield call(service.addPaiementService, data);
    //yield put(actions.loadPaiementAction())
  } catch (error) {
    yield put(actions.loadPaiementErrorAction(error));
  } finally {
    yield put(actions.loadPaiementFinishAction());
  }
}

function* updatePaiement(data) {
  try {
    yield put(actions.loadPaiementRequestAction());
    yield call(service.updatePaiementService, data);
    //yield put(actions.loadPaiementAction())
  } catch (error) {
    yield put(actions.loadPaiementErrorAction(error));
  } finally {
    yield put(actions.loadPaiementFinishAction());
  }
}

function* deletePaiement(data) {
  try {
    yield put(actions.loadPaiementRequestAction());
    yield call(service.deletePaiementService, data);
    yield put(actions.loadPaiementAction());
  } catch (error) {
    yield put(actions.loadPaiementErrorAction(error));
  } finally {
    yield put(actions.loadPaiementFinishAction());
  }
}

function* watchLoadPaiements() {
  yield takeEvery(types.LOAD_PAIEMENTS, loadPaiementsForAllCustomer);
}

function* watchLoadPaiementsClient() {
  yield takeEvery(types.LOAD_PAIEMENTS_CLIENT, loadPaiementsForOneCustomer);
}

function* watchAddPaiements() {
  yield takeEvery(types.ADD_PAIEMENTS, addPaiement);
}

function* watchUpdatePaiements() {
  yield takeEvery(types.UPDATE_PAIEMENTS, updatePaiement);
}

function* watchDeletePaiements() {
  yield takeEvery(types.DELETE_PAIEMENTS, deletePaiement);
}

export function* paiementSaga() {
  yield all([
    watchLoadPaiements(),
    watchLoadPaiementsClient(),
    watchAddPaiements(),
    watchUpdatePaiements(),
    watchDeletePaiements(),
  ]);
}
